import script from "./BitcoinChart.vue?vue&type=script&setup=true&lang=js"
export * from "./BitcoinChart.vue?vue&type=script&setup=true&lang=js"

import "./BitcoinChart.vue?vue&type=style&index=0&id=10c07326&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10c07326"]])

export default __exports__